import projection from '../generated/pwn5mbf1.json';
import { AcceptanceManifest } from '../types';
export const pwn5mbf1AcceptanceManifest = projection as AcceptanceManifest;
